import { render, staticRenderFns } from "./DeansGrid.vue?vue&type=template&id=5d975b8d"
import script from "./DeansGrid.vue?vue&type=script&lang=js"
export * from "./DeansGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports